import { render, staticRenderFns } from "./VehicleEdit.vue?vue&type=template&id=2f0b62ac&"
import script from "./VehicleEdit.vue?vue&type=script&lang=js&"
export * from "./VehicleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports